import React from "react";
import "../styles/ProductsSection.css";

const products = [
  {
    category: "AI Talent Hub",
    description: "Enhance your job profile with AI-driven resume refinement and expert reviews. Empowering AI enthusiasts and professionals, AI Talent Hub connects top-tier AI talent with leading opportunities. Whether you're seeking AI-driven career growth or hiring skilled AI professionals, our platform bridges the gap with smart matchmaking, industry insights, and expert resources. Join AI Talent Hub to accelerate your AI journey!",
    image: "/images/front4.4.jpg",
    link: "#",
  },
  {
    category: "AI Training",
    description: "Master the future with our industry-focused AI Training programs. Designed for beginners and professionals alike, our courses cover Machine Learning, Deep Learning, NLP, Computer Vision, and more. Learn from AI experts, work on real-world projects, and gain hands-on experience with cutting-edge tools. Whether you're upskilling for career growth or starting your AI journey, our structured training ensures you stay ahead in the evolving AI landscape. Enroll today and transform your AI aspirations into reality!",
    image: "/images/front5.5.jpg",
    link: "#",
  },
  // {
  //   category: "Oracle QE Automation",
  //   description: "Enhance your Oracle application testing with our cutting-edge Oracle QE (Quality Engineering) Automation solutions. Our framework streamlines test automation, ensuring faster, more accurate, and efficient validation of Oracle Cloud, EBS, and Fusion applications. With AI-driven test execution, robust test case management, and seamless integration with CI/CD pipelines, our Oracle QE Automation accelerates release cycles while maintaining the highest quality standards. Reduce manual effort, minimize risks, and achieve superior test coverage with our intelligent automation solutions.",
  //   image: "/images/Oracle.png",
  //   link: "#",
  // },
];

const ProductsSection = () => {
  return (
    <div className="products-section">
      <h2 className="section-title1">Products of Instil-it</h2>
      <div className="products-container">
        {products.map((product, index) => (
          <div key={index} className={`product-pair ${index % 2 === 1 ? "reverse-layout" : ""}`}>
            {/* Image Card */}
            <div className="image-card">
              <img src={product.image} alt={product.category} />
            </div>
            {/* Details Card */}
            <div className="details-card">
              <h3>{product.category}</h3>
              <p>{product.description}</p>
              {/* <a href={product.link} className="learn-more-btn">Learn More →</a> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsSection;
